import { useState } from "react";
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
import { t } from "../services/i18n";
import { resetAppData } from "../services/storage";

export default function PrivacyPage() {
  const [resetDone, setResetDone] = useState(false);

  const onReset = () => {
    if (window.confirm(t("privacy.resetConfirm"))) {
      resetAppData();
      setResetDone(true);
    }
  };

  return (
    <>
      <AppHeader title={t("privacy.title")} backTo="/" />
      <div className="page page--with-nav">
        <div className="card">
          <p>{t("privacy.body")}</p>
        </div>
        <div className="card mt-16">
          <h2 className="h2">{t("privacy.resetTitle")}</h2>
          <p style={{ margin: "8px 0 14px", color: "var(--color-text-secondary)" }}>
            {t("privacy.resetBody")}
          </p>
          {resetDone ? (
            <div className="info-banner info-banner--success">{t("privacy.resetDone")}</div>
          ) : (
            <button className="btn-danger" onClick={onReset}>
              {t("privacy.resetButton")}
            </button>
          )}
        </div>
      </div>
      <BottomNavigation />
    </>
  );
}
